import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=0545dae3&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=0545dae3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545dae3",
  null
  
)

export default component.exports